import clueReportNoStrain from './clueReportNoStrain'
export default clueReportNoStrain
